import React, {createContext, useContext, useEffect, useState} from 'react';
import {WebSocketContext} from 'wss/WebSocketService';
import {UserContext} from 'components/user/UserContext';
import {getIgnoredNotificationsRequest} from 'util/api';

const NotificationContext = createContext();

const channelName = 'notification';

export const NotificationProvider = ({children}) => {
    const wsService = useContext(WebSocketContext);
    const [missedMessages, setMissedMessages] = useState(0);
    const [missedNotifications, setMissedNotifications] = useState(0);
    const {user} = useContext(UserContext);

    useEffect(() => {
        if (user.isLoggedIn) {
            getIgnoredNotificationsRequest().then((response) => {
                setMissedNotifications(Number(response.value));
            });
        }
    }, []);

    useEffect(() => {
        const handleMessage = (content, topic) => {
            if (topic === 'missedMessage') {
                setMissedMessages((prevMissedMessages) => prevMissedMessages + 1);
            }
            if (topic === 'newNotification') {
                setMissedNotifications((prevMissedNotifications) => prevMissedNotifications + 1);
            }
        };

        wsService.connect();
        wsService.bindChannel(channelName);
        wsService.onMessage(channelName, handleMessage);

        // Cleanup on unmount
        return () => {
            wsService.unbindChannel(channelName);
        };
    }, [wsService]);

    const resetMissedMessages = () => {
        setMissedMessages(0);
    };

    const resetMissedNotifications = () => {
        setMissedNotifications(0);
    };

    return (
        <NotificationContext.Provider value={{
            missedMessages,
            resetMissedMessages,
            missedNotifications,
            resetMissedNotifications
        }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationContext);